// extracted by mini-css-extract-plugin
export default {"list":"list---g8_V7","list-item":"list-item---NS9e5"};